import { useEffect } from "react";
import { UnmatchedDepositsWidget } from "@/widgets/unmatchedDeposits";

export const UnmatchedDepositsPage = () => {
  useEffect(() => {
    document.title = "Танигдаагүй гүйлгээнүүд";
  }, []);

  return (
    <div className="page">
      <UnmatchedDepositsWidget />
    </div>
  );
};
